jQuery(document).ready(function () {

    // Recharge widget selection
    jQuery(document).on('click', '.first-button', function () {
    const widget = document.querySelector('recharge-subscription-widget');
    let oneTimeOption;

    if (widget && widget.shadowRoot) {
        oneTimeOption = widget.shadowRoot.querySelector('input[value="onetime"]');
    } else {
        oneTimeOption = jQuery('input[value="onetime"]')[0]; // get the DOM element from jQuery
    }

    if (oneTimeOption) oneTimeOption.click();

    jQuery(".product .months-wrap").hide();
    jQuery(".price.once-price").show();
    jQuery(".price.subscription-price").hide();
    jQuery("div.pricing-container div.pricing-option:first-child p.discount").hide();
    jQuery(".onetime-dicount").show();
    jQuery(".subsribe-dicount").hide();
    jQuery("p.discount.onetime-dicount").show();

    jQuery("p.discount.for-mobile").attr("style", "display: none !important;");
jQuery("p.price.subscription-mobile").hide();
jQuery("p.price.one-time-mobile").show();
jQuery(".for-mobile .price.once-price").show();
jQuery("p.price.for-mobile-subs").hide();
jQuery(".for-mobile p.save-price").hide();
jQuery(".for-mobile .subscription-discounyt-first").hide();
jQuery(".subscription-heading").text("One-Time Purchase");



jQuery(".pricing-container div#option1").click();
    

    
    
});

jQuery(document).on('click', '.second-button', function () {
    const widget = document.querySelector('recharge-subscription-widget');
    let subscriptionOption;

    if (widget && widget.shadowRoot) {
        subscriptionOption = widget.shadowRoot.querySelector('input[value="subscription"]');
    } else {
        subscriptionOption = jQuery('input[value="subscription"]')[0];
    }

    if (subscriptionOption) subscriptionOption.click();

    jQuery(".product .months-wrap").show();
    jQuery(".price.once-price").hide();
    jQuery(".price.subscription-price").show();
    jQuery("div.pricing-container div.pricing-option:first-child p.discount").show();
    jQuery(".onetime-dicount").hide();
    jQuery(".subsribe-dicount").show();
    jQuery("p.discount.onetime-dicount").hide();
    jQuery("p.price.subscription-mobile").show();
    jQuery("p.discount.for-mobile").show();
    jQuery("p.price.one-time-mobile").hide();
    jQuery(".for-mobile .price.once-price").hide();
    jQuery("p.price.for-mobile-subs").show();
jQuery(".for-mobile p.save-price").show();
jQuery(".for-mobile .subscription-discounyt-first").show();
    jQuery(".subscription-heading").text("Subscribe & Save");
jQuery(".pricing-container div#option1").click();
    
});


    

    // Variation click price change
    setTimeout(function () {
        jQuery(".pricing-container div:first-child").click();
    }, 1000); // 2 second delay
    jQuery(document).on('click', '.pricing-container div#option1', function () {
        jQuery(".quantity__input").val(1);
    });
    jQuery(document).on('click', '.pricing-container div#option2', function () {
        jQuery(".quantity__input").val(2);
    });
    jQuery(document).on('click', '.pricing-container div#option3', function () {
        jQuery(".quantity__input").val(3);
    });

    // Variation price add class
    $(document).ready(function () {
        $(".pricing-option").click(function () {
            $(".pricing-option").removeClass("active");
            $(this).addClass("active");
        });
    });






    $(".first-sec").addClass("active");
    // $(".sec-sec").addClass("active");

    $(".first-sec, .sec-sec, .third-sec").on("click", function () {
        $(".first-sec, .sec-sec, .third-sec").removeClass("active");
        $(this).addClass("active");
    });

    jQuery(document).on('click', '.first-div.first-sec', function () {
        const rechargeWidget = document.querySelector('recharge-subscription-widget');
        const shadow1 = rechargeWidget.shadowRoot;

        const innerWidget = shadow1.querySelector('rc-selling-plans');
        const shadow2 = innerWidget.shadowRoot;

        const oneTimeOption1 = shadow2.querySelector('input[aria-label="1 month save 20%"]');
        oneTimeOption1.click();
    })

    jQuery(document).on('click', '.first-div.sec-sec', function () {
        const rechargeWidget = document.querySelector('recharge-subscription-widget');
        const shadow1 = rechargeWidget.shadowRoot;

        const innerWidget = shadow1.querySelector('rc-selling-plans');
        const shadow2 = innerWidget.shadowRoot;

        const oneTimeOption1 = shadow2.querySelector('input[aria-label="2 months save 20%"]');
        oneTimeOption1.click();
    })

    jQuery(document).on('click', '.first-div.third-sec', function () {
        const rechargeWidget = document.querySelector('recharge-subscription-widget');
        const shadow1 = rechargeWidget.shadowRoot;

        const innerWidget = shadow1.querySelector('rc-selling-plans');
        const shadow2 = innerWidget.shadowRoot;

        const oneTimeOption1 = shadow2.querySelector('input[aria-label="3 months save 20%"]');
        oneTimeOption1.click();
    })



    jQuery(document).ready(function () {
    setTimeout(function () {
        const rechargeWidget = document.querySelector('recharge-subscription-widget');
        const shadow1 = rechargeWidget.shadowRoot;

        const innerWidget = shadow1.querySelector('rc-selling-plans');
        const shadow2 = innerWidget.shadowRoot;

        const oneTimeOption1 = shadow2.querySelector('input[aria-label="1 month save 20%"]');
        oneTimeOption1.click();
    }, 1500);

});


    jQuery('ul.footer-block__details-content a.link').on('click', function () {
        jQuery(this).toggleClass('active');
    });


    // Scroll click on subscribe and scoll
    jQuery(document).on("click", ".why-subscribe-section a.cta-button, .common-buy-now", function (e) {
        e.preventDefault();

        jQuery("html, body").animate({
            scrollTop: 190
        }, 700);
    });


    function scrollWithOffset() {
        if (window.location.hash === '#subscribe-section') {

            var target = $('#subscribe-section');

            if (target.length) {
                var offset = target.offset().top - 400;


                $('html, body').stop().animate({
                    scrollTop: 190
                }, 700);
            }
        }
    }


    if (window.location.hash) {
        setTimeout(function () {
            window.scrollTo(0, 0);
        }, 1);
    }

    setTimeout(scrollWithOffset, 600);


$(".offer-btn").each(function(){
    $(this).click(function(){
$(this).addClass('active');    
        $(this).siblings().removeClass('active');
        
    });

});
jQuery(document).ready(function ($) {

  $('.faq-item').removeClass('active').prop('open', false);

  $(document).on('click', '.faq-question', function (e) {
    e.preventDefault();

    const $details = $(this).closest('.faq-item');
    const isOpen = $details.prop('open');

    $('.faq-item').removeClass('active').prop('open', false);
    $('.faq-icon').text('+');

    if (!isOpen) {
      $details.addClass('active').prop('open', true);
      $(this).find('.faq-icon').text('-');
    }
  });

});


const offerTextLine = $('.content-wrapper p.offer-text').next('p');

// When "Buy once" clicked
$('.first-button').on('click', function(){
  $('.first-button').addClass('active');
  $('.second-button').removeClass('active');

  // Existing text updates
  $('.longevity-offer-buttons .left-btn .main-text').text('Just £6.99');
  $('.longevity-offer-buttons .left-btn .sub-text').text('Usually £34.99');
  $('.longevity-offer-buttons .right-btn').text("I Don’t Need It");
  $('.longevity-offer-box h3').html('<b>Add The Real Life Longevity Framework Book?</b>');

  // Show offer line again
  offerTextLine.show();
});

// When "Subscribe & Save" clicked
$('.second-button').on('click', function(){
  $('.second-button').addClass('active');
  $('.first-button').removeClass('active');

  // Existing text updates
  $('.longevity-offer-buttons .left-btn .main-text').text('Free For Subscribers');
  $('.longevity-offer-buttons .left-btn .sub-text').text('Normally £34.99');
  $('.longevity-offer-buttons .right-btn').text("I Don’t Want The Free Book");
  $('.longevity-offer-box h3').html('<b>Supplements Work Better With A Framework</b>');

  // Hide only this line
  offerTextLine.hide();
});

}); 

function resetOfferSelection() {
  jQuery('.longevity-offer-buttons .offer-btn').removeClass('active');
}


/* =====================================================
   BUY ONCE / SUBSCRIBE TOGGLE
===================================================== */
const $firstBtn  = jQuery('.first-button');   // Buy once
const $secondBtn = jQuery('.second-button');  // Subscribe

function resetOfferSelection() {
  jQuery('.longevity-offer-buttons .offer-btn').removeClass('active');
}

/* ===== NEW FUNCTION ADDED ===== */
function syncBookWithPlan() {
  const $offerLeft  = jQuery('.offer-btn.left-btn');
  const $offerRight = jQuery('.offer-btn.right-btn');

  resetOfferSelection();

  // If Subscribe active → Select LEFT (Book)
  if ($secondBtn.hasClass('active')) {
    $offerLeft.addClass('active');
  }

  // If Buy Once active → Select RIGHT (No Book)
  if ($firstBtn.hasClass('active')) {
    $offerRight.addClass('active');
  }
}

// Buy once
$firstBtn.on('click', function () {
  jQuery(this).addClass('active');
  $secondBtn.removeClass('active');
  resetOfferSelection();

  /* NEW */
  syncBookWithPlan();
});

// Subscribe
$secondBtn.on('click', function () {
  jQuery(this).addClass('active');
  $firstBtn.removeClass('active');
  resetOfferSelection();

  /* NEW */
  syncBookWithPlan();
});

// Default: Subscribe active
jQuery(document).ready(function () {
  $secondBtn.addClass('active');
  $firstBtn.removeClass('active');
  resetOfferSelection();

  /* NEW */
  syncBookWithPlan();
});




jQuery(document).ready(function($) {
  $('.book-price-card').removeClass('active');
  $('.book-price-card').first().addClass('active');
  $('.book-price-card').on('click', function() {
    $('.book-price-card').removeClass('active');
    $(this).addClass('active');
  });
});

